import { IDailyOdometer } from "../../model/DutyStatusLogs";
import { createAction, ActionsUnion } from "../definitions";
import { DailyOdometerActionTypes } from "./types";

export interface IDailyOdometerPayload {
    userId: string;
    dailyOdometer?: IDailyOdometer;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DailyOdometerActions = {
    clearDailyOdometer: (payload: IDailyOdometerPayload) => createAction(DailyOdometerActionTypes.CLEAR_DAILYODOMETER, payload),
    setDailyOdometer: (payload: IDailyOdometerPayload) => createAction(DailyOdometerActionTypes.SET_DAILYODOMETER, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DailyOdometerActions = ActionsUnion<typeof DailyOdometerActions>;